export default __webpack_public_path__ + "media/images/header_logo-863f24e05b2c76a02afa92682bcdba50.png";